export default __webpack_public_path__ + "static/media/screen1_man.b0e073ef.png";